const comments = [
  {
    name: '漫画迷小明',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20abstract%20avatar%20portrait%20with%20soft%20gradient%20coral%20colors%2C%20minimalist%20circle%20design%2C%20clean%20background%20with%20subtle%20texture&width=100&height=100&seq=avatar-01&orientation=squarish',
    text: '非常爱漫画真的是宝藏网站！更新的速度太快了，我追的几部国漫每次都能第一时间看到最新章节。下拉式阅读体验也很流畅，比翻页舒服多了。',
    time: '2小时前',
    likes: 128,
  },
  {
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20warm%20peach%20toned%20abstract%20avatar%20design%20with%20gentle%20curves%2C%20minimalist%20circle%20composition%2C%20clean%20background%20with%20subtle%20organic%20shapes&width=100&height=100&seq=avatar-02&orientation=squarish',
    text: '从朋友那里被安利了爱漫画，现在每天都在上面看免费漫画，资源真的很全！日漫韩漫都有，而且不用注册登录就能直接看，太方便了。',
    time: '5小时前',
    likes: 96,
  },
  {
    name: '追更达人老张',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20amber%20toned%20abstract%20avatar%20with%20geometric%20shapes%2C%20minimalist%20circle%20design%2C%20clean%20simple%20background%20with%20warm%20texture&width=100&height=100&seq=avatar-03&orientation=squarish',
    text: '作为十多年的漫画老读者，爱漫画的资源丰富程度让我惊喜。从经典老番到最新连载，应有尽有。下拉式阅读对手机党太友好了，通勤路上追更超方便。',
    time: '昨天',
    likes: 203,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">读者评论</h2>
          <p className="text-sm text-foreground-500">听听漫画爱好者们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 flex flex-col">
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{comment.text}</p>
              <div className="mt-4 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}